import HeroCarousel from "./components/HeroCarousel";
import CategoryStrip from "./components/CategoryStrip";
import LatestVideos from "./components/LatestVideos";
import HotRanking from "./components/HotRanking";
import { getFeaturedVideos } from "@/data/videos";
import usePageMeta from "@/hooks/usePageMeta";

export default function Home() {
  const featured = getFeaturedVideos();

  usePageMeta(
    "免费视频网站91-免费高清在线视频资源平台",
    "免费视频网站91致力于为用户提供丰富的免费视频内容，涵盖多种类别，让您轻松在线观看各类高清视频，体验流畅观影乐趣。",
    "免费视频网站91,免费视频,在线视频观看,免费高清视频,在线影视资源",
  );

  return (
    <>
      <HeroCarousel videos={featured} />
      <CategoryStrip />
      <LatestVideos />
      <HotRanking />
    </>
  );
}